const cups = [
  {
    masters: 28,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 16,
    inCut: 4,
    pointsForCut: 12,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 23,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 11,
    inCut: 4,
    pointsForCut: 7,
    bubbledIn: 1,
    bubbledOut: 1,
  },
  {
    masters: 30,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 13,
    inCut: 4,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 4,
  },
  {
    masters: 57,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 5,
    bubbledOut: 0,
  },
  {
    masters: 32,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 1,
    bubbledOut: 0,
  },
  {
    masters: 28,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 0,
  },
  {
    masters: 15,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 0,
  },
  {
    masters: 27,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 2,
  },
  {
    masters: 20,
    inCut: 4,
    pointsForCut: 11,
    bubbledIn: 1,
    bubbledOut: 0,
  },
  {
    masters: 19,
    inCut: 4,
    pointsForCut: 11,
    bubbledIn: 1,
    bubbledOut: 0,
  },
  {
    masters: 14,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 1,
    bubbledOut: 0,
  },
  {
    masters: 13,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 1,
  },
  {
    masters: 18,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 0,
  },
  {
    masters: 61,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 26,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 1,
  },
  {
    masters: 25,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 32,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 1,
  },
  {
    masters: 28,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 0,
  },
  {
    masters: 15,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 1,
    bubbledOut: 1,
  },
  {
    masters: 14,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 0,
  },
  {
    masters: 24,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 17,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 1,
    bubbledOut: 1,
  },
  {
    masters: 38,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 2,
    bubbledOut: 1,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 6,
    bubbledOut: 2,
  },
  {
    masters: 24,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 1,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 2,
  },
  {
    masters: 34,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 2,
    bubbledOut: 4,
  },
  {
    masters: 19,
    inCut: 4,
    pointsForCut: 12,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 49,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 5,
    bubbledOut: 2,
  },
  {
    masters: 24,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 7,
    bubbledOut: 0,
  },
  {
    masters: 40,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 6,
    bubbledOut: 0,
  },
  {
    masters: 23,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 3,
    bubbledOut: 4,
  },
  {
    masters: 56,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 1,
    bubbledOut: 1,
  },
  {
    masters: 28,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 2,
  },
  {
    masters: 22,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 3,
    bubbledOut: 1,
  },
  {
    masters: 26,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 0,
  },
  {
    masters: 24,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 7,
    bubbledOut: 0,
  },
  {
    masters: 37,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 2,
    bubbledOut: 4,
  },
  {
    masters: 22,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 2,
    bubbledOut: 1,
  },
  {
    masters: 12,
    inCut: 4,
    pointsForCut: 9,
    bubbledIn: 2,
    bubbledOut: 1,
  },
  {
    masters: 12,
    inCut: 4,
    pointsForCut: 8,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 34,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 3,
    bubbledOut: 4,
  },
  {
    masters: 29,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 1,
  },
  {
    masters: 24,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 43,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 2,
    bubbledOut: 1,
  },
  {
    masters: 13,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 1,
    bubbledOut: 0,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 19,
    inCut: 4,
    pointsForCut: 12,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 25,
    inCut: 8,
    pointsForCut: 8,
    bubbledIn: 1,
    bubbledOut: 0,
  },
  {
    masters: 13,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 44,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 6,
    bubbledOut: 1,
  },
  {
    masters: 29,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 1,
  },
  {
    masters: 28,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 1,
  },
  {
    masters: 32,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 26,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 25,
    inCut: 8,
    pointsForCut: 8,
    bubbledIn: 1,
    bubbledOut: 0,
  },
  {
    masters: 28,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 0,
  },
  {
    masters: 52,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 4,
    bubbledOut: 2,
  },
  {
    masters: 22,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 2,
  },
  {
    masters: 27,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 29,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 2,
  },
  {
    masters: 30,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 44,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 1,
    bubbledOut: 6,
  },
  {
    masters: 27,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 4,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 0,
  },
  {
    masters: 20,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 1,
    bubbledOut: 1,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 3,
    bubbledOut: 2,
  },
  {
    masters: 51,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 5,
    bubbledOut: 1,
  },
  {
    masters: 23,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 6,
    bubbledOut: 0,
  },
  {
    masters: 34,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 45,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 5,
    bubbledOut: 0,
  },
  {
    masters: 26,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 0,
  },
  {
    masters: 27,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 31,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 33,
    inCut: 8,
    pointsForCut: 11,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 33,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 3,
    bubbledOut: 3,
  },
  {
    masters: 36,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 1,
    bubbledOut: 4,
  },
  {
    masters: 42,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 22,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 28,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 52,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 34,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 40,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 1,
    bubbledOut: 5,
  },
  {
    masters: 32,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 3,
    bubbledOut: 3,
  },
  {
    masters: 13,
    inCut: 4,
    pointsForCut: 9,
    bubbledIn: 2,
    bubbledOut: 2,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 2,
    bubbledOut: 2,
  },
  {
    masters: 17,
    inCut: 4,
    pointsForCut: 12,
    bubbledIn: 4,
    bubbledOut: 0,
  },
  {
    masters: 24,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 23,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 3,
    bubbledOut: 1,
  },
  {
    masters: 19,
    inCut: 4,
    pointsForCut: 10,
    bubbledIn: 2,
    bubbledOut: 2,
  },
  {
    masters: 24,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 0,
  },
  {
    masters: 34,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 49,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 2,
    bubbledOut: 10,
  },
  {
    masters: 29,
    inCut: 8,
    pointsForCut: 10,
    bubbledIn: 5,
    bubbledOut: 2,
  },
  {
    masters: 21,
    inCut: 8,
    pointsForCut: 9,
    bubbledIn: 2,
    bubbledOut: 2,
  },
  {
    masters: 34,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 1,
    bubbledOut: 3,
  },
  {
    masters: 34,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 2,
    bubbledOut: 10,
  },
  {
    masters: 49,
    inCut: 8,
    pointsForCut: 12,
    bubbledIn: 1,
    bubbledOut: 4,
  },
  {
    masters: 45,
    inCut: 8,
    pointsForCut: 13,
    bubbledIn: 3,
    bubbledOut: 0,
  },
  {
    masters: 13,
    inCut: 4,
    pointsForCut: 9,
    bubbledIn: 1,
    bubbledOut: 4,
  },
];

export default cups;
